import { Table } from '@skytech/ui'
import PlusIcon from 'mdi-react/PlusIcon'
import { useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'

import { useAppContext } from '@/App.context'
import Page from '@/components/content/Page'
import ButtonLink from '@/components/util/ButtonLink'
import Error from '@/components/util/feedback/Error'
import ListLoader from '@/components/util/ListLoader'
import {
  getCustomerListExceedsLimit,
  getError,
  getVisibleCustomers,
  increaseListRenderLimit,
} from '@/ducks/customersReducer'
import withCustomersLoaded from '@/hocs/withCustomersLoaded'
import { useIsBechtle } from '@/hooks/user'
import { appRoutes } from '@/util/misc'

import { Translation } from '../i18n/Translation'

import CustomerListItem from './CustomerListItem'
import CustomersFilter from './CustomersFilter'

import './customer-list.scss'

const CustomerList = () => {
  const dispatch = useDispatch()
  const { whiteLabel } = useAppContext()

  const customers = useSelector(getVisibleCustomers)
  const error = useSelector(getError)
  const isBechtle = useIsBechtle()

  return (
    <Page className="customer-list">
      <h1>
        <Translation id="Customers" />
      </h1>

      <div className={`customer-list__options wl-${whiteLabel}`}>
        <ButtonLink to={appRoutes.newCustomer}>
          <PlusIcon />
          <Translation id="Create Customer" />
        </ButtonLink>
      </div>

      {error && <Error textId={error} />}

      <CustomersFilter />

      <Table rowHeight="tall">
        <thead>
          <tr>
            {!isBechtle && (
              <th>
                <Translation id="Enterprise" />
              </th>
            )}

            <th>
              <Translation id="Name" />
            </th>

            <th className="hidden sm:table-cell">
              <Translation id="Org.nbr." />
            </th>

            <th className="hidden sm:table-cell">
              <Translation id="Whitelabel" />
            </th>

            <th className="hidden sm:table-cell">
              <Translation id="Customer status" />
            </th>

            {isBechtle && (
              <th className="hidden sm:table-cell">
                <Translation id="VAT Number" />
              </th>
            )}

            <th className="hidden sm:table-cell">
              <Translation id="Street Address" />
            </th>

            {isBechtle && (
              <th className="hidden text-right sm:table-cell">
                <Translation id="Employees" />
              </th>
            )}

            {!isBechtle && (
              <th className="hidden sm:table-cell">
                <Translation id="Billing Address" />
              </th>
            )}
          </tr>
        </thead>

        <tbody>
          {customers.map(customer => (
            <CustomerListItem key={customer.id} {...customer} />
          ))}
        </tbody>
      </Table>

      <ListLoader
        // @ts-ignore
        conditionSelector={getCustomerListExceedsLimit}
        action={() => dispatch(increaseListRenderLimit())}
      />
    </Page>
  )
}
// @ts-ignore
export default compose(C => withCustomersLoaded(C, true))(CustomerList)
